import React, { useCallback } from "react";
import { connect } from "react-redux";

import cn from "classnames";
import { defineMessages, useIntl } from "react-intl";

import { EntityType, EntityTypesSupportingRoutes } from "@mapmycustomers/shared/types/entity";

import addCompaniesIcon from "@app/assets/map/leadFinder/addCompanies.svg";
import addPeopleIcon from "@app/assets/map/leadFinder/addPeople.svg";
import { initializeAddRecords } from "@app/scene/map/store/actions";
import { getAddRecordsEntityType } from "@app/scene/map/store/selectors";
import { RootState } from "@app/store/rootReducer";

import styles from "./ModeSwitch.module.scss";

const messages = defineMessages({
  companies: {
    id: "map.tool.leadFinder.addRecords.modeSwitch.companies",
    defaultMessage: "Companies",
    description: "Companies",
  },
  people: {
    id: "map.tool.leadFinder.addRecords.modeSwitch.people",
    defaultMessage: "People",
    description: "People",
  },
});

interface Props {
  onChange?: (value: EntityTypesSupportingRoutes) => void;
  onInitialize: typeof initializeAddRecords.request;
  value?: EntityTypesSupportingRoutes;
}

const ModeSwitch: React.FC<Props> = ({ onChange, onInitialize, value }) => {
  const intl = useIntl();

  const handleChange = useCallback(
    (entityType: EntityTypesSupportingRoutes) => {
      if (value !== entityType) {
        onChange?.(entityType);
        onInitialize({ entityType: entityType });
      }
    },
    [onChange, onInitialize, value]
  );

  const handleCompaniesClick = useCallback(() => {
    handleChange(EntityType.COMPANY);
  }, [handleChange]);

  const handlePersonsClick = useCallback(() => {
    handleChange(EntityType.PERSON);
  }, [handleChange]);

  return (
    <div className={styles.container}>
      <div
        className={cn(styles.btn, { [styles.btnActive]: value === EntityType.COMPANY })}
        onClick={handleCompaniesClick}
      >
        <img
          alt={intl.formatMessage(messages.companies)}
          className={styles.icon}
          src={addCompaniesIcon}
        />
        <div className={styles.title}>{intl.formatMessage(messages.companies)}</div>
      </div>

      <div
        className={cn(styles.btn, { [styles.btnActive]: value === EntityType.PERSON })}
        onClick={handlePersonsClick}
      >
        <img
          alt={intl.formatMessage(messages.people)}
          className={styles.icon}
          src={addPeopleIcon}
        />
        <div className={styles.title}>{intl.formatMessage(messages.people)}</div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  entityType: getAddRecordsEntityType(state),
});

const mapDispatchToProps = {
  onInitialize: initializeAddRecords.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModeSwitch);
